'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnlinepbxRaiting = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var OnlinepbxRaiting = exports.OnlinepbxRaiting = function OnlinepbxRaiting(_ref) {
  var title = _ref.title,
      raiting = _ref.raiting;

  var colors = ['#E51C23', '#FA4C15', '#FF8F0C', '#FFC90C', '#01C716'];
  return _react2['default'].createElement(
    'div',
    { title: title, className: 'onlinepbx__lib__raiting' },
    Array(5).fill(raiting).map(function (round, index) {
      return _react2['default'].createElement('div', { key: index, style: { background: raiting > index && colors[raiting - 1] }, className: 'onlinepbx__lib__raiting__round' });
    })
  );
};

exports['default'] = OnlinepbxRaiting;